import React from 'react';
import EcoTabImgs, { EcoTabImgsItem } from 'eco-design/sections-test/eco-tab-imgs';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const D: React.FC = () => {
    const { t } = useLang('theProduct.D');

    const items: EcoTabImgsItem[] = [
        {
            tabLabel: t('tab1'),
            tabValue: '0',
            imgs: [
                {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1762477815768-8sxopu-compressed-On-the-go%EF%BC%881920/1366%EF%BC%89.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1762477827912-nokjkz-compressed-768/375.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312230397/1-1.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312227813/1-1-h5.jpg',
                },
            ],
        },
        {
            tabLabel: t('tab2'),
            tabValue: '1',
            imgs: [
                {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1762996995083-exia9g-compressed-travel%EF%BC%881920/1366%EF%BC%89.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1762997012287-zjoepm-compressed-768/375.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312228995/1-3.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312228744/1-3-h5.jpg',
                },
            ],
        },
        {
            tabLabel: t('tab3'),
            tabValue: '2',
            imgs: [
                {
                    pc: 'https://websiteoss.ecoflow.com/figma-uploads/1762478051226-3hff1o-compressed-at%20home%EF%BC%881920/1366%EF%BC%89.jpg',
                    h5: 'https://websiteoss.ecoflow.com/figma-uploads/1762478061425-2ehmhg-compressed-768/375.jpg',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1750312230807/2-2.jpg',
                    h5: 'https://websiteoss.ecoflow.com/upload/image/1750312229646/2-2-h5.jpg',
                },
            ],
        },
    ];

    return (
        <section
            id="rapid-mag-D"
            className={`rapid-mag-D ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-D'}
            data-section-title={t('title')}
        >
            <div className="info">
                <p className="title">{t('title')}</p>
            </div>
            <EcoTabImgs className={css.comp} items={items} />
        </section>
    );
};
export default D;
